import { string } from 'fp-ts';
import { PaymentRequestTableRecord } from '@mews-commander/data-access';

export const comparePaymentRequestByCreatedUtc = (a: PaymentRequestTableRecord, b: PaymentRequestTableRecord) =>
    string.Ord.compare(a.createdUtc, b.createdUtc);
